import UIBaseContainer from "@baseUI/component/base/UIBaseComponent";

export default class SettingsPartContainer extends UIBaseContainer {

    constructor() {
        super()
    }

    updateSize(uiModelView){
    }
}